{
  "DisplayasoptionsGrid": "Grille",
  "DisplayasoptionsColumns": "Colonnes",
  "DisplayasoptionsRows": "Rangs",
  "DisplayasoptionsChart": "Graphique",
  "DisplayasoptionsDetailedtableview": "Vue détaillée du tableau",
  "DisplayasoptionsBlfviewhorizontal": "Vue BLF (horizontale)",
  "DisplayasoptionsBlfviewvertical": "Vue BLF (verticale)",
  "DisplayasoptionsChartview": "Vue graphique",
  "NAME": "DisplayedAsOptions"
}